import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTablePFSEvent } from "primereact/datatable";
import { UserRoles } from "../../../../../constants/userRoles";
import { PrivateAccess } from "../../../../../keycloak";

import classes from "./JobZoneList.module.scss";

type JobZoneListProps = {
  first?: number;
  rows?: number;
  totalRecords?: number;
  records: [any];
  rowActionEdit: (rowData: any) => void;
  rowActionDelete: (rowData: any) => void;
  onPage: (e: DataTablePFSEvent) => void;
};

export const JobZoneList = ({
  first,
  rows,
  totalRecords,
  records,
  rowActionDelete,
  rowActionEdit,
  onPage,
}: JobZoneListProps) => {
  const actionBodyTemplate = (rowData: any) => {
    return (
      <div className={classes.tableActions}>
        <PrivateAccess
          roles={{
            dcs_client: [UserRoles.JOB_ZONE_UPDATE],
          }}
        >
          <Button
            icon="pi pi-pencil"
            className="p-button-primary mr-2 p-button-sm"
            onClick={() => rowActionEdit(rowData)}
          />
        </PrivateAccess>
        <PrivateAccess
          roles={{
            dcs_client: [UserRoles.JOB_ZONE_DELETE],
          }}
        >
          <Button
            icon="pi pi-trash"
            className="p-button-danger p-button-sm"
            onClick={() => rowActionDelete(rowData)}
          />
        </PrivateAccess>
      </div>
    );
  };
  return (
    <DataTable
      value={records}
      paginator={true}
      paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPage={onPage}
      paginatorPosition="top"
      paginatorClassName={classes.paginator}
      lazy
    >
      <Column field="zoneCode" header="Code"></Column>
      <Column field="name" header="Name"></Column>
      <Column
        field="supervisorId"
        header="Supervisors"
        body={(rowData: any) => (
          <span>
            {rowData?.supervisor
              ?.map((supervisor: any) =>
                `${supervisor?.firstName ?? ""} ${supervisor?.lastName ?? ""}`.trim()
              )
              .filter(Boolean)
              .join(", ")}
          </span>
        )}
      ></Column>
      <Column
        style={{ width: "150px" }}
        body={actionBodyTemplate}
        header="Actions"
      ></Column>
    </DataTable>
  );
};
